import { useCallback } from 'react';
import format from 'date-fns/format';

import type { ApiAcceptedLanguage } from '@izimi/api';
import { useLocaleStore } from '@izimi/core';

export const useDateLocale = (language: ApiAcceptedLanguage) => {
  const { locale, setLocale } = useLocaleStore();

  setLocale(language);

  return locale;
};

export const useFormatDate = (language: ApiAcceptedLanguage) => {
  const locale = useDateLocale(language);

  return useCallback(
    (...args: Parameters<typeof format>) => {
      return format(args[0], args[1], { locale, ...args[2] });
    },
    [locale],
  );
};
